{
  "COMPOSE_REDIRECT": {
    "OPENING": "Đang mở cuộc trò chuyện mới với {email}…",
    "NO_EMAIL": "Chưa cung cấp địa chỉ email. Dùng ?email=name@example.com",
    "CONTACT_ERROR": "Không thể tìm thấy liên hệ cho {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Vui lòng chọn một cuộc trò chuyện từ ngăn bên trái",
    "CSAT_REPLY_MESSAGE": "Bạn hãy vui lòng đánh giá hội thoại",
    "404": "Xin lỗi, chúng tôi không thể tìm thấy hội thoại. Vui lòng thử lại",
    "SWITCH_VIEW_LAYOUT": "Chuyển đổi bố cục",
    "DASHBOARD_APP_TAB_MESSAGES": "Tin nhắn",
    "UNVERIFIED_SESSION": "Danh tính của người dùng này không được xác thực",
    "NO_MESSAGE_1": "Uh oh! Có vẻ như không có tin nhắn nào từ khách hàng trong hộp thư đến của bạn.",
    "NO_MESSAGE_2": " gửi tin nhắn đến trang của bạn!",
    "NO_INBOX_1": "Hola! Có vẻ như bạn chưa thêm bất kỳ hộp thư đến nào.",
    "NO_INBOX_2": " để bắt đầu",
    "NO_INBOX_AGENT": "Uh Oh! Có vẻ như bạn không thuộc bất kỳ hộp thư đến nào. Vui lòng liên hệ với quản trị viên của bạn",
    "SEARCH_MESSAGES": "Tìm kiếm tin nhắn trong các hội thoại",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Bản dịch",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Tìm kiếm tin nhắn",
      "RESULT_TITLE": "Các kết quả tìm kiếm",
      "LOADING_MESSAGE": "Định dạng dữ liệu...",
      "PLACEHOLDER": "Nhập bất kỳ văn bản nào để tìm kiếm tin nhắn",
      "NO_MATCHING_RESULTS": "Không tìm thấy kết quả."
    },
    "UNREAD_MESSAGES": "Tin nhắn chưa đọc",
    "UNREAD_MESSAGE": "Tin nhắn chưa đọc",
    "CLICK_HERE": "Click vào đây",
    "LOADING_INBOXES": "Đang tải hộp thư đến",
    "LOADING_CONVERSATIONS": "Đang tải cuộc trò chuyện",
    "CANNOT_REPLY": "Bạn không thể trả lời do",
    "24_HOURS_WINDOW": "Giới hạn thời lượng tin nhắn 24 giờ",
    "NOT_ASSIGNED_TO_YOU": "Hội thoại này không được phân công cho bạn. Bạn có muốn phân công hội thoại này cho chính mình?",
    "ASSIGN_TO_ME": "Phân công cho tôi",
    "TWILIO_WHATSAPP_CAN_REPLY": "Bạn chỉ có thể phản hồi hội thoại này bằng tin nhắn mẫu vì",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Giới hạn thời lượng tin nhắn 24 giờ",
    "REPLYING_TO": "Bạn đang trả lời:",
    "REMOVE_SELECTION": "Xóa lựa chọn",
    "DOWNLOAD": "Tải xuống",
    "UNKNOWN_FILE_TYPE": "Tập tin chưa xác định",
    "SAVE_CONTACT": "Lưu liên hệ",
    "NO_CONTENT": "Không có nội dung để hiển thị",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Trước khi gửi, vui lòng thực hiện:",
      "EXECUTE": "Thực hiện",
      "RETRY": "Thử lại",
      "CONFIRM": "Thực hiện ngay?",
      "CONFIRM_YES": "Có, thực hiện",
      "CONFIRM_NO": "Hủy",
      "RUNNING": "Đang thực hiện…",
      "DONE": "Đã xong",
      "CLAIM_DELAYED": "sẽ được tạo khi đơn hàng được giao",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Đã tạo khiếu nại MỚI {reference}, {planned} đã đóng — vui lòng chỉnh sửa nội dung bản nháp",
        "NEW_CLAIM": "Đã tạo khiếu nại MỚI {reference} thay vì cập nhật {planned} — vui lòng chỉnh sửa nội dung bản nháp",
        "OTHER_CLAIM": "Đã cập nhật khiếu nại {reference} thay vì {planned} — vui lòng chỉnh sửa nội dung bản nháp",
        "EXISTING_CLAIM": "Không tạo khiếu nại mới, đã cập nhật khiếu nại hiện có {reference} — vui lòng chỉnh sửa nội dung bản nháp",
        "OTHER": "Kết quả khác với giả định của bản nháp — vui lòng chỉnh sửa nội dung bản nháp"
      },
      "FAILED": "Thất bại",
      "UNREACHABLE": "Không thể kết nối với bot",
      "REQUEST_FAILED": "Không thể bắt đầu thao tác, vui lòng thử lại.",
      "ACTIONS": {
        "CANCEL_ORDER": "Hủy đơn hàng",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Đổi phương thức thanh toán sang thanh toán khi nhận hàng",
        "CREATE_CLAIM": "Tạo khiếu nại",
        "CREATE_OR_UPDATE_CLAIM": "Tạo hoặc cập nhật khiếu nại",
        "EXTEND_ORDER_PICKUP_DATE": "Gia hạn thời hạn nhận hàng"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Đang tải file đính kèm...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Tin nhắn được xoá thành công",
    "FAIL_DELETE_MESSSAGE": "Không thể xoá tin nhắn! Thử lại",
    "NO_RESPONSE": "Không có phản hồi",
    "RESPONSE": "Response",
    "RATING_TITLE": "Đánh giá",
    "FEEDBACK_TITLE": "Phản hồi",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Hiển thị nhãn",
      "HIDE_LABELS": "Ẩn nhãn"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Giải quyết",
      "REOPEN_ACTION": "Mở lại",
      "OPEN_ACTION": "Mở",
      "OPEN": "Nhiều",
      "CLOSE": "Đóng",
      "DETAILS": "chi tiết",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Tạm dừng đến ngày mai",
      "SNOOZED_UNTIL_NEXT_WEEK": "Tạm dừng đến tuần sau",
      "SNOOZED_UNTIL_NEXT_REPLY": "Tạm dừng đến khi có phản hồi",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "quá hạn"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Đánh dấu chưa giải quyết",
      "SNOOZE_UNTIL": "Báo lại",
      "SNOOZE": {
        "TITLE": "Tạm dừng đến khi",
        "NEXT_REPLY": "Phản hồi kế tiếp",
        "TOMORROW": "Ngày mai",
        "NEXT_WEEK": "Tuần sau"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Tạm dừng đến khi",
      "APPLY": "Báo lại",
      "CANCEL": "Huỷ"
    },
    "PRIORITY": {
      "TITLE": "Mức độ ưu tiên",
      "OPTIONS": {
        "NONE": "Không có",
        "URGENT": "Cấp bách",
        "HIGH": "Cao",
        "MEDIUM": "Trung bình",
        "LOW": "Thấp"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Không có",
        "INPUT_PLACEHOLDER": "Chọc mức ưu tiên",
        "NO_RESULTS": "Không tìm thấy kết quả",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Mở trong tab mới",
      "COPY_LINK": "Sao chép liên kết cuộc trò chuyện",
      "COPY_LINK_SUCCESS": "Đã sao chép liên kết cuộc trò chuyện vào bộ nhớ tạm",
      "PENDING": "Đánh dấu chưa giải quyết",
      "RESOLVED": "Đánh dấu là đã giải quyết",
      "MARK_AS_UNREAD": "Đánh dấu là chưa đọc",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Mở lại hội thoại",
      "SNOOZE": {
        "TITLE": "Báo lại",
        "NEXT_REPLY": "Cho đến phản hồi kế tiếp",
        "TOMORROW": "Cho đến ngày mai",
        "NEXT_WEEK": "Cho đến tuần sau"
      },
      "ASSIGN_AGENT": "Gán tổng đài viên",
      "ASSIGN_LABEL": "Gán nhãn",
      "AGENTS_LOADING": "Đang tải điện thoại viên...",
      "ASSIGN_TEAM": "Gán nhóm",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Id hội thoại {conversationId} được gán cho \"{agentName}\"",
          "FAILED": "Không thể gán điện thoại viên. Vui lòng thử lại."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Không thể gán nhãn. Vui lòng thử lại."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Đã gán nhóm \"{team}\" cho hội thoại id {conversationId}",
          "FAILED": "Không thể gán nhóm. Vui lòng thử lại."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Chữ ký tin nhắn",
      "ENABLE_SIGN_TOOLTIP": "Bật chữ ký",
      "DISABLE_SIGN_TOOLTIP": "Tắt chữ ký",
      "MSG_INPUT": "Shift + enter cho dòng mới. Bắt đầu với '/' để chọn Câu trả lời soạn trước.",
      "PRIVATE_MSG_INPUT": "Shift + enter cho dòng mới. Điều này sẽ chỉ hiển thị cho Đại lý",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Chứ ký cuối tin nhắn chưa được cài đặt, xin hãy cài đặt một chữ ký trong phần cài đặt hồ sơ.",
      "CLICK_HERE": "Bấm vào đây để cập nhật",
      "WHATSAPP_TEMPLATES": "Mẫu Whatsapp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "Cửa sổ 24 giờ của Whatsapp đã hết hạn. Vui lòng trả lời bằng tin nhắn mẫu.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Câu trả lời của bạn có vẻ bằng {draftLanguage}, nhưng cuộc trò chuyện này bằng {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Dịch",
      "REPLY": "Trả lời",
      "PRIVATE_NOTE": "Lưu ý riêng",
      "SEND": "Gửi",
      "CREATE": "Thêm ghi chú",
      "INSERT_READ_MORE": "Đọc thêm",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_FORMAT_ICON": "Hiển thị trình soạn thảo văn bản đa dạng thức",
      "HEADING_LEVEL": {
        "LABEL": "Kiểu văn bản",
        "NORMAL": "Văn bản thường",
        "H1": "Tiêu đề 1",
        "H2": "Tiêu đề 2",
        "H3": "Tiêu đề 3"
      },
      "EDITOR": {
        "BOLD": "Đậm",
        "ITALIC": "Nghiêng",
        "UNDERLINE": "Gạch chân",
        "TEXT_COLOR": "Màu chữ",
        "BG_COLOR_LABEL": "Màu nền",
        "FONT_SIZE_LABEL": "Cỡ chữ",
        "FONT_SIZE": {
          "XS": "Nhỏ",
          "SM": "Nhỏ vừa",
          "MD": "Mặc định",
          "LG": "Lớn",
          "XL": "Rất lớn",
          "XXL": "Cực lớn"
        },
        "CODE": "Mã",
        "LINK": "Thêm hoặc xóa liên kết",
        "CREATE_LINK": "Tạo liên kết",
        "SAVE_LINK": "Lưu",
        "CANCEL": "Hủy",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Hoàn tác",
        "REDO": "Làm lại",
        "BULLET_LIST": "Danh sách dấu đầu dòng",
        "ORDERED_LIST": "Danh sách có số thứ tự",
        "BLOCKQUOTE": "Trích dẫn",
        "H1": "Tiêu đề 1",
        "H2": "Tiêu đề 2",
        "H3": "Tiêu đề 3",
        "IMAGE_UPLOAD": "Tải ảnh lên",
        "CLEAR_FORMATTING": "Xóa định dạng",
        "COLOR": {
          "RED": "Đỏ",
          "YELLOW": "Vàng",
          "BLUE": "Xanh dương",
          "ROSE_RED": "Đỏ hoa hồng",
          "DEEP_CYAN": "Lam đậm",
          "ORANGE": "Cam",
          "PISTACHIO": "Xanh hồ trăn",
          "PURPLE": "Tím",
          "FUCHSIA": "Hồng sặc sỡ",
          "SILVER": "Bạc",
          "NAVY": "Xanh navy",
          "OLD_PINK": "Hồng cổ điển",
          "AQUA": "Xanh ngọc",
          "BROWN": "Nâu",
          "OLIVE": "Xanh ô liu",
          "GOLD": "Vàng kim",
          "BEIGE": "Be",
          "WINE": "Đỏ rượu vang",
          "FOREST": "Xanh rừng",
          "GREEN": "Xanh lá",
          "BLUE_GREY": "Xanh xám",
          "RUBY_RED": "Đỏ ruby",
          "CHESTNUT_BROWN": "Nâu hạt dẻ",
          "ASH_GREY": "Xám tro"
        },
        "BG_COLOR": {
          "RED": "Đỏ",
          "YELLOW": "Vàng",
          "BLUE": "Xanh dương",
          "ROSE_RED": "Đỏ hoa hồng",
          "DEEP_CYAN": "Lam đậm",
          "ORANGE": "Cam",
          "PISTACHIO": "Xanh hồ trăn",
          "PURPLE": "Tím",
          "FUCHSIA": "Hồng sặc sỡ",
          "SILVER": "Bạc",
          "NAVY": "Xanh navy",
          "OLD_PINK": "Hồng cổ điển",
          "AQUA": "Xanh ngọc",
          "BROWN": "Nâu",
          "OLIVE": "Xanh ô liu",
          "GOLD": "Vàng kim",
          "BEIGE": "Be",
          "WINE": "Đỏ rượu vang",
          "FOREST": "Xanh rừng",
          "GREEN": "Xanh lá",
          "BLUE_GREY": "Xanh xám",
          "RUBY_RED": "Đỏ ruby",
          "CHESTNUT_BROWN": "Nâu hạt dẻ",
          "ASH_GREY": "Xám tro"
        }
      },
      "TIP_EMOJI_ICON": "Hiển thị chọn emoji",
      "TIP_ATTACH_ICON": "Đính kèm tệp",
      "TIP_AUDIORECORDER_ICON": "Ghi âm thanh",
      "TIP_AUDIORECORDER_PERMISSION": "Cho phép truy cập ghi âm",
      "TIP_AUDIORECORDER_ERROR": "Không thể mở bản ghi âm",
      "DRAG_DROP": "Kéo thả vào đây để đính kèm",
      "START_AUDIO_RECORDING": "Bắt đầu ghi âm",
      "STOP_AUDIO_RECORDING": "Dừng ghi âm",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Thêm bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Các e\u001dmail phân biệt bởi dấu phẩy",
          "ERROR": "Vui lòng điền địa chỉ email hợp lệ"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Các e\u001dmail phân biệt bởi dấu phẩy",
          "ERROR": "Vui lòng điền địa chỉ email hợp lệ"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Gửi",
          "CANCEL": "Huỷ"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Thêm một hộp thư SMS để gửi trả lời SMS.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Lưu ý riêng: Chỉ hiển thị với bạn và nhóm của bạn",
    "CHANGE_STATUS": "Trạng thái cuộc trò chuyện đã thay đổi",
    "CHANGE_STATUS_FAILED": "Thay đổi trạng thái hội thoại không thành công",
    "CHANGE_AGENT": "Người Được Chỉ Định Cuộc Hội Thoại đã thay đổi",
    "CHANGE_AGENT_FAILED": "Thay đổi người được gán không thành công",
    "ASSIGN_LABEL_SUCCESFUL": "Đã gán nhãn thành công",
    "ASSIGN_LABEL_FAILED": "Gán nhãn không thành công",
    "CHANGE_TEAM": "Nhóm hội thoại đã được thay đổi",
    "FILE_SIZE_LIMIT": "Tệp vượt quá {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB mức hạn chế",
    "MESSAGE_ERROR": "Không thể gửi tin nhắn này, vui lòng thử lại sau",
    "SENT_BY": "Gửi bởi:",
    "BOT": "Bot",
    "SEND_FAILED": "Không thể gửi tin nhắn! Thử lại",
    "TRY_AGAIN": "thử lại",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Chọn tổng đài viên",
      "REMOVE": "Xoá",
      "ASSIGN": "Gán"
    },
    "CONTEXT_MENU": {
      "COPY": "Sao Chép",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Xoá",
      "CREATE_A_CANNED_RESPONSE": "Thêm vào câu trả lời soạn sẵn",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Xoá",
        "CANCEL": "Huỷ"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Liên hệ",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Cuộc trò chuyện được đánh dấu là đã giải quyết bởi {userName}",
          "CONTACT_RESOLVED": "Hội thoại đã được giải quyết bởi {contactName}",
          "OPEN": "Cuộc trò chuyện đã được mở lại bởi {userName}",
          "PENDING": "Hội thoại được đánh dấu là chưa giải quyết bởi {userName}",
          "SNOOZED": "Hội thoại đã được tạm dừng lại bởi {userName}",
          "AUTO_RESOLVED": "Hội thoại được đánh dấu là đã giải quyết bởi hệ thống vì {duration} ngày không hoạt động",
          "SYSTEM_AUTO_OPEN": "Hệ thống mở lại hội thoại do có tin nhắn mới.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Hệ thống đã giải quyết hội thoại vì ticket đã được đóng trên Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} thiết lập độ ưu tiên thành {newPriority}",
          "UPDATED": "{userName} thay đổi mức độ ưu tiên từ {oldPriority} thành {newPriority}",
          "REMOVED": "{userName} bỏ mức độ ưu tiên"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} phân công chính mình vào hội thoại này",
          "ASSIGNED": "Chỉ định {assigneeName} bởi {userName}",
          "REMOVED": "Cuộc hội thoại chưa được chỉ định bởi {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Chỉ định {teamName} bởi {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Phân công cho {assigneeName} thông qua {teamName} bởi {userName}",
          "REMOVED": "Huỷ phân công cho {teamName} bởi {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} thêm {labels}",
          "REMOVED": "{userName} xoá {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} đã tắt tiếng hội thoại",
        "UNMUTED": "{userName} đã bật tiếng cuộc trò chuyện",
        "CONTACT_BLOCKED": "{userName} đã chặn liên hệ",
        "CONTACT_UNBLOCKED": "{userName} đã bỏ chặn liên hệ",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Đã chuyển vì đơn hàng của liên hệ chỉ đến từ cửa hàng {storeName} (đơn gần nhất {orderId}), có robot trả lời trong hộp thư này.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Tự động hóa đã bị bỏ qua vì liên hệ đã bị chặn",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Tự động hoá \"{ruleName}\" không thể chuyển cuộc trò chuyện này từ hộp thư đến {sourceInboxName} sang hộp thư đến {targetInboxName} vì các hộp thư đến không tương thích.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Tự động hoá \"{ruleName}\" không thể chuyển cuộc trò chuyện này từ hộp thư đến {sourceInboxName} sang hộp thư đến {targetInboxName} vì liên hệ không có địa chỉ email.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Tự động hoá \"{ruleName}\" không thể gửi tin nhắn: hộp thư đến điện thoại này không thể gửi SMS vì tài khoản không có hộp thư đến SMS. Quy tắc đã bị tắt và các quản trị viên đã nhận được email.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Tự động hoá \"{ruleName}\" không thể gửi tin nhắn: không thể gửi tệp đính kèm qua SMS từ hộp thư đến này. Quy tắc đã bị tắt và các quản trị viên đã nhận được email.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Macro \"{macroName}\" đã không gửi tin nhắn của nó: hộp thư đến điện thoại này không thể gửi SMS vì tài khoản không có hộp thư đến SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Macro \"{macroName}\" đã không gửi tin nhắn của nó: không thể gửi tệp đính kèm qua SMS từ hộp thư đến này.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Macro \"{macroName}\" đã không gửi tin nhắn của nó: Bot đang xử lý cuộc hội thoại này. Hãy mở cuộc hội thoại trước.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Macro \"{macroName}\" đã không gửi tin nhắn của nó: hộp thư đến này đã được đánh dấu để xóa. Hãy chuyển cuộc hội thoại sang hộp thư đến khác trước.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Tự động hoá \"{ruleName}\" đã gửi email đến {contactEmail} trong cuộc trò chuyện mới [#{conversationId}]({conversationPath}) ở hộp thư đến {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Tự động hoá \"{ruleName}\" đã bắt đầu cuộc trò chuyện này vì cuộc trò chuyện [#{conversationId}]({conversationPath}) ở hộp thư đến {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Tự động hoá \"{ruleName}\" không thể gửi tin nhắn trong cuộc trò chuyện mới ở hộp thư đến {inboxName} vì liên hệ không có địa chỉ email.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Tự động hoá \"{ruleName}\" đã gửi SMS đến {contactPhone} trong cuộc trò chuyện mới [#{conversationId}]({conversationPath}) ở hộp thư đến {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Tự động hoá \"{ruleName}\" không thể gửi SMS trong cuộc trò chuyện mới ở hộp thư đến {inboxName} vì liên hệ không có số điện thoại.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Đại lý",
            "CUSTOMER": "Khách hàng"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "đã được trả lời ở máy khác, đổ chuông {duration}",
            "NO_ANSWER": "không trả lời, đổ chuông {duration}",
            "REJECTED": "từ chối sau khi đổ chuông {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Tự động giải quyết sau số lần gọi lại không thành công: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Bản ghi cuộc gọi đã bị {name} xóa, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Khách hàng không nhìn thấy",
    "SENT_VIA_EMAIL": "Cũng đã gửi cho liên hệ qua email ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Hộp thư đến này đã được đánh dấu để xóa, nên câu trả lời của khách hàng sẽ không bao giờ đến nơi. Hãy chuyển cuộc hội thoại sang hộp thư đến khác để trả lời.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Liên hệ này có một hội thoại mở khác #{id}",
      "MULTIPLE": "Liên hệ này có các hội thoại mở khác ({count})",
      "OPEN": "Mở",
      "SHOW": "Hiển thị"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Yêu cầu khách hàng chia sẻ số điện thoại WhatsApp của họ",
      "PENDING_ACTION": "Yêu cầu thông tin liên hệ đang chờ xử lý",
      "STATES": {
        "PENDING": "Đang chờ thông tin liên hệ",
        "SHARED": "Đã chia sẻ số điện thoại",
        "IDENTITY_CONFLICT": "Số điện thoại cần được kiểm tra lại"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Gửi bản ghi cuộc trò chuyện",
    "DESC": "Gửi bản sao của bản ghi cuộc trò chuyện đến địa chỉ email được chỉ định",
    "SUBMIT": "Gửi",
    "CANCEL": "Huỷ",
    "SEND_EMAIL_SUCCESS": "Bản ghi cuộc trò chuyện đã được gửi thành công",
    "SEND_EMAIL_ERROR": "Có lỗi, xin vui lòng thử lại",
    "FORM": {
      "SEND_TO_CONTACT": "Gửi bảng điểm cho khách hàng",
      "SEND_TO_AGENT": "Gửi bản ghi cho tổng đài viên được phân công",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Gửi bản ghi tới một địa chỉ email khác",
      "EMAIL": {
        "PLACEHOLDER": "Nhập địa chỉ emai",
        "ERROR": "Vui lòng nhập một địa chỉ email hợp lệ"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Xin chào 👋, Chào mừng đến với {installationName}!",
    "DESCRIPTION": "Cảm ơn bạn đã đăng ký. Chúng tôi muốn bạn khai thác tối đa {installationName}. Dưới đây là một số điều bạn có thể làm trong {installationName} để mang lại trải nghiệm thú vị.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Đọc cập nhật mới nhất của chúng tôi",
    "ALL_CONVERSATION": {
      "TITLE": "Tất cả hội thoại của bạn ở cùng một chỗ",
      "DESCRIPTION": "Xem tất cả hội thoại từ khách hàng của bạn trong cùng một trang. Bạn có thể lọc các hội thoại theo kênh, nhãn và trạng thái.",
      "NEW_LINK": "Bấm vào đây để tạo mới một kênh"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Mời các thành viên trong nhóm của bạn",
      "DESCRIPTION": "Vì bạn đã sẵn sàng để chào và đón tiếp khách hàng của mình, hãy lôi kéo đồng đội để hỗ trợ bạn. Bạn có thể mời đồng đội của mình bằng cách thêm địa chỉ email của họ vào danh sách tổng đài viên.",
      "NEW_LINK": "Bấm vào đây để mời đồng đội"
    },
    "LABELS": {
      "TITLE": "Tổ chức hội thoại theo nhãn",
      "DESCRIPTION": "Nhãn cung cấp một cách để phân loại các hội thoại của bạn dễ dàng hơn. Tạo một số nhãn như #ho-tro, #\byeu-cau-bao-gia, v. v. để bạn có thể sử dụng chúng trong hội thoại sau này.",
      "NEW_LINK": "Bấm vào đây để tạo nhãn"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Tổng đài viên được phân công",
    "SELF_ASSIGN": "Phân công cho tôi",
    "TEAM_LABEL": "Nhóm được phân công",
    "SELECT": {
      "PLACEHOLDER": "Không có"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Chi tiết liên hệ",
      "CONVERSATION_ACTIONS": "Hành động của \bhội thoại",
      "CONVERSATION_LABELS": "Nhãn hội thoại",
      "CONVERSATION_INFO": "Thông tin hội thoại",
      "CONTACT_ATTRIBUTES": "Thuộc tính của liên hệ",
      "PREVIOUS_CONVERSATION": "Cuộc trò chuyện trước đó",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Chờ giải quyết",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Tạo thuộc tính",
    "NO_RECORDS_FOUND": "Không có thuộc tính nào được tìm thấy",
    "UPDATE": {
      "SUCCESS": "Thuộc tính cập nhật thành công",
      "ERROR": "Không thể cập nhật thuộc tính. Vui lòng thử lại sau"
    },
    "ADD": {
      "TITLE": "Thêm",
      "SUCCESS": "Thuộc tính được thêm thành công",
      "ERROR": "Không thể thêm thuộc tính. Vui lòng thử lại sau"
    },
    "DELETE": {
      "SUCCESS": "Thuộc tính xoá thành công",
      "ERROR": "Không thể xoá thuộc tính. Vui lòng thử lại sau"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Thêm thuộc tính",
      "PLACEHOLDER": "Tìm kiếm thuộc tính",
      "NO_RESULT": "Không có thuộc tính nào được tìm thấy"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Từ",
    "TO": "Đến",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Chủ đề"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Không tìm thấy kết quả",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Số đơn hàng",
    "EXTERNAL_ID": "ID bên ngoài",
    "PAYMENT_TYPE": "Phương thức thanh toán",
    "PAYMENT_DATE": "Ngày thanh toán",
    "DELIVERY_PROVIDER": "Đơn vị vận chuyển",
    "EXPECTED_DATE_OF_DELIVERY": "Dự kiến giao hàng",
    "DATE_OF_DELIVERY": "Giao vào",
    "EXPEDITION_DATE": "Ngày gửi hàng",
    "INTERNAL_NOTE": "Ghi chú cửa hàng",
    "PACKAGE_NUMBER": "Bưu kiện"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
